export default {
  vat: {
    title: 'VAT Identification Number',
    status_label: 'VAT Status',
    statuses: {
      pending_verification: 'Pending Verification',
      failed_verification: 'Failed Verification',
      verified: 'Verified',
    },
    countryCode: 'Country',
    vatId: 'VAT Identification Number',
    edit: 'Edit',
    addVat: 'Add a VAT Number',
    updateVat: 'Update VAT Number',
    save: 'Save',
    countryAlreadyUsed: 'You may only have one VAT Number per country.',
    vatIdExamples: 'Valid format(s) for %{countryName}: %{formats}.',
    vatIdAlphanumeric: 'Only letters and numbers.',
    vatEmptyStateMessage: 'Your shop may be required to have a VAT number depending on your country.',
    learnMore: 'Learn more.',
    saveFailed: 'Sorry, your VAT Number should match the following format(s):',
    deleteFailed: 'Sorry, your VAT Number could not be deleted. Please try again.',
  },
  onboardingBillingMethodLink: {
    completeBillingMethod: 'Complete Billing Method',
  },
};
